import type { Organization } from '../types';

export const organizationsMock: Organization[] = [
  {
    id: 'org-001',
    name: 'Acme Corporation',
    ownerId: 'user-001',
    createdAt: '2025-01-01T00:00:00.000Z',
    avatarUrl: null,
    description: null,
    websiteUrl: null,
    tier: 'free',
    role: 'owner',
  },
  {
    id: 'org-002',
    name: 'Stark Industries',
    ownerId: 'user-002',
    createdAt: '2025-02-01T00:00:00.000Z',
    avatarUrl: null,
    description: null,
    websiteUrl: null,
    tier: 'pro',
    role: 'admin',
  },
  {
    id: 'org-003',
    name: 'Wayne Enterprises',
    ownerId: 'user-003',
    createdAt: '2025-03-01T00:00:00.000Z',
    avatarUrl: null,
    description: null,
    websiteUrl: null,
    tier: 'free',
    role: 'collaborator',
  },
];
